import { Link, LinkProps } from "@mui/material";

import React from "react";

const BNLink: React.FC<LinkProps> = (props) => {
  const { sx: sxInput, ...restOfProps } = props;

  const sx = [
    {
      cursor: "pointer",
    },
    // You cannot spread `sx` directly because `SxProps` (typeof sx) can be an array.
    ...(Array.isArray(sxInput) ? sxInput : [sxInput]),
  ];

  return <Link sx={sx} {...restOfProps}></Link>;
};
export default BNLink;
